/* ===========================================================================
   TEAM FIT — Ostrich Golf
   Motor del configurador de equipaciones (sections/team-fit-wizard.liquid).

   Vanilla JS, ES5, sin dependencias, en un IIFE — igual que assets/main.js y
   que los controladores en línea del hero y de la ficha de producto. Se carga
   con `defer` desde la propia sección, así que solo pesa en /pages/team-fit.

   ---------------------------------------------------------------------------
   Cómo está montado

   Hay UN objeto `state` con todo lo que el usuario ha contestado y una función
   `go(n)` que cambia de paso. El DOM no guarda nada: cada control escribe en
   `state` y cada repintado lee de `state`. Por eso ir y volver entre pasos no
   pierde datos y el resumen del paso 7 no puede desincronizarse de lo elegido.

   La validación es por paso y solo mira lo obligatorio de ESE paso (lo pide el
   brief): `validate(n)` devuelve el primer campo que falla, `go` no avanza si
   hay fallo y el mensaje se pinta junto al campo, no en un alert.

   Los textos visibles NO están aquí: viajan desde Liquid en un
   <script type="application/json" data-tf-strings> que rellenan los locales,
   así que el wizard habla todos los idiomas del tema sin tocar este archivo.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-team-fit]');
  if (!root) return;

  /* ----------------------------------------------------------------------
     1. Utilidades
  ---------------------------------------------------------------------- */
  function $(sel, ctx) {
    return (ctx || root).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }
  function on(el, type, fn, opts) {
    if (el) el.addEventListener(type, fn, opts);
  }
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }
  function esc(str) {
    return String(str == null ? '' : str);
  }

  /* Los rótulos de los botones del tema van duplicados dentro de .roll (el
     hover de rodillo, snippets/roll.liquid): hay DOS nodos de texto, no uno.
     Se actualizan los dos, igual que hace la ficha de producto. */
  function setRoll(btn, text) {
    if (!btn) return;
    var lines = btn.querySelectorAll('.roll__line');
    if (!lines.length) {
      btn.textContent = text;
      return;
    }
    for (var i = 0; i < lines.length; i++) lines[i].textContent = text;
  }

  var strings = {};
  try {
    var box = $('[data-tf-strings]');
    if (box) strings = JSON.parse(box.textContent) || {};
  } catch (e) {
    strings = {};
  }
  function t(key, fallback) {
    return strings[key] || fallback || '';
  }

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     2. Estado

     `products` guarda el objeto completo de cada tarjeta elegida (no solo el
     id) porque el resumen del paso 7 necesita el nombre y la miniatura, y
     volver a buscarlos en el DOM obligaría a que el paso 3 siguiera montado.
  ---------------------------------------------------------------------- */
  var TOTAL = 7;

  var state = {
    step: 1,
    team: '',
    members: 0,
    garment: '', // 'polo' | 'jersey' | 'both'
    picked: { polo: [], jersey: [] },
    logo: '', // 'yes' | 'no'
    spot: '',
    file: null,
    fileUrl: '', // lo rellena el endpoint de subida, si hay
    notes: '',
    name: '',
    email: '',
    phone: ''
  };

  /* Qué categorías se piden en el paso 3 según lo elegido en el paso 2. */
  function activeCats() {
    if (state.garment === 'polo') return ['polo'];
    if (state.garment === 'jersey') return ['jersey'];
    if (state.garment === 'both') return ['polo', 'jersey'];
    return [];
  }

  function pickedAll() {
    return state.picked.polo.concat(state.picked.jersey);
  }

  /* ----------------------------------------------------------------------
     3. Errores de campo

     Un solo par de funciones para todo el formulario: marcan el contenedor
     .tf-field (que es quien tiñe el filete) y escriben en su .tf-error.
     `aria-invalid` va en el control para que el lector de pantalla lo anuncie.
  ---------------------------------------------------------------------- */
  function clearError(field) {
    if (!field) return;
    field.classList.remove('is-invalid');
    var msg = $('.tf-error', field);
    if (msg) msg.textContent = '';
    var ctrl = field.querySelector('input, textarea, select');
    if (ctrl) ctrl.removeAttribute('aria-invalid');
  }

  function setError(field, message) {
    if (!field) return;
    field.classList.add('is-invalid');
    var msg = $('.tf-error', field);
    if (msg) msg.textContent = message;
    var ctrl = field.querySelector('input, textarea, select');
    if (ctrl) ctrl.setAttribute('aria-invalid', 'true');
  }

  function clearStepErrors(stepEl) {
    $$('.tf-field', stepEl).forEach(clearError);
    $$('.tf-error', stepEl).forEach(function (el) {
      if (!el.closest('.tf-field')) {
        el.classList.remove('is-on');
        el.textContent = '';
      }
    });
  }

  /* Aviso suelto (los pasos de tarjetas no tienen .tf-field que teñir). */
  function setLooseError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-on');
  }

  /* ----------------------------------------------------------------------
     4. Paso 1 — equipo y slider
  ---------------------------------------------------------------------- */
  var teamInput = $('[data-tf-team]');
  var slider = $('[data-tf-slider]');
  var sliderNum = $('[data-tf-slider-num]');
  var sliderUnit = $('[data-tf-slider-unit]');

  on(teamInput, 'input', function () {
    state.team = teamInput.value.trim();
    if (state.team) clearError(teamInput.closest('.tf-field'));
  });

  function paintSlider() {
    if (!slider) return;
    var min = parseFloat(slider.min) || 0;
    var max = parseFloat(slider.max) || 100;
    var val = parseFloat(slider.value);
    state.members = val;

    /* El relleno de la pista es un degradado duro con el corte en --tf-fill.
       Se compensan los 28 px del pulgar para que el color termine en su
       centro y no en el borde de la pista. */
    var ratio = max === min ? 0 : (val - min) / (max - min);
    slider.style.setProperty('--tf-fill', (ratio * 100).toFixed(2) + '%');

    if (sliderNum) sliderNum.textContent = val;
    if (sliderUnit) {
      sliderUnit.textContent = val === 1 ? t('member_one', 'integrante') : t('member_other', 'integrantes');
    }
    slider.setAttribute('aria-valuetext', val + ' ' + (sliderUnit ? sliderUnit.textContent : ''));
  }

  on(slider, 'input', paintSlider);
  if (slider) paintSlider();

  /* ----------------------------------------------------------------------
     5. Pasos 2 y 4 — tarjetas de elección (una sola)

     Un solo manejador para los tres grupos de opción única: el grupo se
     identifica con data-tf-group y el valor con data-tf-value.
  ---------------------------------------------------------------------- */
  function selectOne(group, value) {
    $$('[data-tf-group="' + group + '"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-tf-value') === value ? 'true' : 'false');
    });
  }

  $$('[data-tf-group]').forEach(function (btn) {
    on(btn, 'click', function () {
      var group = btn.getAttribute('data-tf-group');
      var value = btn.getAttribute('data-tf-value');

      if (group === 'garment') {
        /* Cambiar de tipo de prenda invalida lo elegido en el paso 3: si se
           pasa de «Polo + Jersey» a «Polo», los jerseys marcados ya no
           pertenecen a la solicitud. Se limpia solo lo que deja de pedirse. */
        var prev = state.garment;
        state.garment = value;
        if (prev && prev !== value) {
          if (activeCats().indexOf('polo') === -1) state.picked.polo = [];
          if (activeCats().indexOf('jersey') === -1) state.picked.jersey = [];
          syncProductCards();
        }
        selectOne(group, value);
        paintCats();
        hideNavNote();
      } else if (group === 'logo') {
        state.logo = value;
        selectOne(group, value);
        toggleLogoBlock(value === 'yes');
        hideNavNote();
      } else if (group === 'spot') {
        state.spot = value;
        selectOne(group, value);
        hideNavNote();
      }
    });
  });

  /* ----------------------------------------------------------------------
     6. Paso 3 — productos
  ---------------------------------------------------------------------- */
  var catBlocks = $$('[data-tf-cat]');
  var stepThreeTitle = $('[data-tf-products-title]');

  function paintCats() {
    var cats = activeCats();
    catBlocks.forEach(function (block) {
      var name = block.getAttribute('data-tf-cat');
      block.hidden = cats.indexOf(name) === -1;
    });

    /* Título dinámico: singular si solo se pide una prenda, plural si se
       piden las dos. */
    if (stepThreeTitle) {
      stepThreeTitle.textContent =
        cats.length > 1
          ? t('step3_title_plural', 'Elegid vuestros productos')
          : t('step3_title_single', 'Elige vuestro producto');
    }
    paintCounts();
  }

  function paintCounts() {
    $$('[data-tf-count]').forEach(function (el) {
      var cat = el.getAttribute('data-tf-count');
      var n = state.picked[cat] ? state.picked[cat].length : 0;
      var word = n === 1 ? t('count_one', 'seleccionado') : t('count_selected', 'seleccionados');
      el.textContent = n === 0 ? t('count_none', 'Ninguno seleccionado') : n + ' ' + word;
      el.classList.toggle('is-on', n > 0);
    });
  }

  function findPicked(cat, id) {
    var list = state.picked[cat] || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return i;
    }
    return -1;
  }

  $$('[data-tf-product]').forEach(function (card) {
    on(card, 'click', function () {
      var cat = card.getAttribute('data-tf-product');
      var id = card.getAttribute('data-tf-id');
      var idx = findPicked(cat, id);

      if (idx > -1) {
        state.picked[cat].splice(idx, 1);
        card.setAttribute('aria-pressed', 'false');
      } else {
        state.picked[cat].push({
          id: id,
          title: card.getAttribute('data-tf-title') || '',
          image: card.getAttribute('data-tf-image') || '',
          price: card.getAttribute('data-tf-price') || ''
        });
        card.setAttribute('aria-pressed', 'true');
      }
      paintCounts();
      hideNavNote();
    });
  });

  /* Repinta el aria-pressed de todas las tarjetas desde `state`. Hace falta
     cuando el estado cambia sin pulsar la tarjeta: al cambiar de tipo de
     prenda en el paso 2. */
  function syncProductCards() {
    $$('[data-tf-product]').forEach(function (card) {
      var cat = card.getAttribute('data-tf-product');
      var id = card.getAttribute('data-tf-id');
      card.setAttribute('aria-pressed', findPicked(cat, id) > -1 ? 'true' : 'false');
    });
    paintCounts();
  }

  /* ----------------------------------------------------------------------
     7. Paso 4 — personalización y subida del logotipo
  ---------------------------------------------------------------------- */
  var logoBlock = $('[data-tf-logo-block]');
  var drop = $('[data-tf-drop]');
  var fileInput = $('[data-tf-file]');
  var fileCard = $('[data-tf-file-card]');
  var fileName = $('[data-tf-file-name]');
  var fileSize = $('[data-tf-file-size]');
  var fileThumb = $('[data-tf-file-thumb]');
  var fileRemove = $('[data-tf-file-remove]');
  var fileError = $('[data-tf-file-error]');

  var MAX_BYTES = (parseFloat(root.getAttribute('data-tf-max-mb')) || 10) * 1024 * 1024;
  var ALLOWED = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'application/pdf'];
  var ALLOWED_EXT = ['png', 'jpg', 'jpeg', 'svg', 'pdf'];

  function toggleLogoBlock(open) {
    if (!logoBlock) return;
    logoBlock.classList.toggle('is-open', !!open);
    /* Cerrado queda `inert`: sus controles no deben ser enfocables con el
       tabulador aunque el contenedor siga en el árbol (lo necesita la
       animación de grid-template-rows). */
    if (open) {
      logoBlock.removeAttribute('inert');
    } else {
      logoBlock.setAttribute('inert', '');
    }
  }

  function humanSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function fileExt(name) {
    var parts = String(name).toLowerCase().split('.');
    return parts.length > 1 ? parts.pop() : '';
  }

  function acceptFile(file) {
    if (!file) return;

    if (fileError) {
      fileError.classList.remove('is-on');
      fileError.textContent = '';
    }

    /* Se comprueban tipo MIME Y extensión: algunos sistemas mandan los SVG
       como text/plain o con el tipo vacío, y rechazarlos por eso sería un
       falso negativo justo con el formato más habitual para un logotipo. */
    var typeOk = ALLOWED.indexOf(file.type) > -1;
    var extOk = ALLOWED_EXT.indexOf(fileExt(file.name)) > -1;
    if (!typeOk && !extOk) {
      setLooseError(fileError, t('file_type_error', 'Formato no admitido. Sube un PNG, JPG, SVG o PDF.'));
      if (fileInput) fileInput.value = '';
      return;
    }

    if (file.size > MAX_BYTES) {
      setLooseError(
        fileError,
        t('file_size_error', 'El archivo supera el tamaño máximo.') + ' (' + humanSize(MAX_BYTES) + ')'
      );
      if (fileInput) fileInput.value = '';
      return;
    }

    state.file = file;
    state.fileUrl = '';

    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = humanSize(file.size);

    /* Previsualización solo de mapas de bits y SVG. El PDF se queda con el
       icono: pintarlo pediría un visor entero por una miniatura de 56 px. */
    if (fileThumb) {
      var isImage = /^image\//.test(file.type) || ['png', 'jpg', 'jpeg', 'svg'].indexOf(fileExt(file.name)) > -1;
      var pdf = $('[data-tf-thumb-icon]', fileThumb);
      var img = $('[data-tf-thumb-img]', fileThumb);

      /* El icono es un <svg>: SVGElement no tiene la propiedad `hidden` (es
         de HTMLElement), así que `pdf.hidden = true` no escribía el atributo
         y la ficha enseñaba la miniatura Y el icono a la vez. Se va al
         atributo directamente. */
      var showIcon = function (on) {
        if (!pdf) return;
        if (on) pdf.removeAttribute('hidden');
        else pdf.setAttribute('hidden', '');
      };

      if (isImage && window.URL && window.URL.createObjectURL) {
        /* Se revoca la anterior: cada createObjectURL retiene el archivo en
           memoria hasta que se suelta. */
        if (img.src && img.src.indexOf('blob:') === 0) window.URL.revokeObjectURL(img.src);
        img.src = window.URL.createObjectURL(file);
        img.hidden = false;
        showIcon(false);
      } else {
        img.hidden = true;
        showIcon(true);
      }
    }

    if (fileCard) fileCard.classList.add('is-on');
    if (drop) drop.hidden = true;
  }

  function clearFile() {
    state.file = null;
    state.fileUrl = '';
    if (fileInput) fileInput.value = '';
    if (fileCard) fileCard.classList.remove('is-on');
    if (drop) {
      drop.hidden = false;
      drop.classList.remove('is-over');
    }
    var img = fileThumb ? $('[data-tf-thumb-img]', fileThumb) : null;
    if (img && img.src && img.src.indexOf('blob:') === 0) {
      window.URL.revokeObjectURL(img.src);
      img.removeAttribute('src');
    }
  }

  on(fileRemove, 'click', clearFile);
  on(fileInput, 'change', function () {
    if (fileInput.files && fileInput.files[0]) acceptFile(fileInput.files[0]);
  });

  /* La caja es un <label for>, así que el clic ya abre el selector del
     sistema por sí solo: aquí solo se añade el arrastrar y soltar y el
     teclado (Enter/Espacio sobre el label no dispara el input en todos los
     navegadores). */
  if (drop) {
    ['dragenter', 'dragover'].forEach(function (type) {
      on(drop, type, function (ev) {
        ev.preventDefault();
        drop.classList.add('is-over');
      });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (type) {
      on(drop, type, function () {
        drop.classList.remove('is-over');
      });
    });
    on(drop, 'drop', function (ev) {
      ev.preventDefault();
      var dt = ev.dataTransfer;
      if (dt && dt.files && dt.files[0]) acceptFile(dt.files[0]);
    });
    on(drop, 'keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
        ev.preventDefault();
        if (fileInput) fileInput.click();
      }
    });
    /* El foco viaja al input escondido; el anillo se pinta en la caja. */
    on(fileInput, 'focus', function () {
      drop.classList.add('is-focus');
    });
    on(fileInput, 'blur', function () {
      drop.classList.remove('is-focus');
    });
  }

  /* ----------------------------------------------------------------------
     8. Pasos 5 y 6 — observaciones y contacto
  ---------------------------------------------------------------------- */
  var notes = $('[data-tf-notes]');
  on(notes, 'input', function () {
    state.notes = notes.value.trim();
  });

  ['name', 'email', 'phone'].forEach(function (key) {
    var input = $('[data-tf-contact="' + key + '"]');
    on(input, 'input', function () {
      state[key] = input.value.trim();
      clearError(input.closest('.tf-field'));
    });
  });

  /* Validación de email pragmática: algo, arroba, algo, punto, algo. No se
     persigue el RFC —ninguna expresión razonable lo cubre— sino cazar el
     error de dedo antes de que la solicitud se pierda. */
  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  /* Teléfono: dígitos, espacios, guiones, paréntesis y un + inicial. Se cuenta
     que haya al menos 6 cifras para no aceptar un «---». */
  function validPhone(value) {
    if (!/^[+\d\s().-]{6,}$/.test(value)) return false;
    return (value.replace(/\D/g, '') || '').length >= 6;
  }

  /* ----------------------------------------------------------------------
     9. Validación por paso

     Devuelve true si el paso está completo. Si no, pinta el error, deja el
     foco en el primer campo que falla y devuelve false. Solo mira lo
     obligatorio del paso actual: nunca bloquea por algo de un paso posterior.
  ---------------------------------------------------------------------- */
  var navNote = $('[data-tf-nav-note]');

  function hideNavNote() {
    if (navNote) {
      navNote.classList.remove('is-on');
      navNote.textContent = '';
    }
  }

  function fail(el, message, field) {
    if (field) setError(field, message);
    else setLooseError(navNote, message);
    if (el && el.focus) {
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
      if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: prefersReduced ? 'auto' : 'smooth' });
    }
    return false;
  }

  function validate(n) {
    var stepEl = $('[data-tf-step="' + n + '"]');
    if (stepEl) clearStepErrors(stepEl);
    hideNavNote();

    if (n === 1) {
      if (!state.team) {
        return fail(teamInput, t('err_team', 'Escribe el nombre del equipo.'), teamInput.closest('.tf-field'));
      }
      return true;
    }

    if (n === 2) {
      if (!state.garment) {
        return fail($('[data-tf-group="garment"]'), t('err_garment', 'Elige qué queréis diseñar.'));
      }
      return true;
    }

    if (n === 3) {
      var cats = activeCats();
      for (var i = 0; i < cats.length; i++) {
        if (!state.picked[cats[i]].length) {
          var block = $('[data-tf-cat="' + cats[i] + '"]');
          var msg =
            cats.length > 1
              ? t('err_products_each', 'Elige al menos un producto de cada categoría.')
              : t('err_products', 'Elige al menos un producto.');
          return fail(block ? $('[data-tf-product]', block) : null, msg);
        }
      }
      return true;
    }

    if (n === 4) {
      if (!state.logo) {
        return fail($('[data-tf-group="logo"]'), t('err_logo', 'Indica si queréis añadir vuestro logotipo.'));
      }
      if (state.logo === 'yes' && !state.spot) {
        return fail($('[data-tf-group="spot"]'), t('err_spot', 'Elige dónde va el logotipo.'));
      }
      return true;
    }

    /* Paso 5: todo opcional, siempre válido. */
    if (n === 5) return true;

    if (n === 6) {
      var nameInput = $('[data-tf-contact="name"]');
      var emailInput = $('[data-tf-contact="email"]');
      var phoneInput = $('[data-tf-contact="phone"]');

      if (!state.name) {
        return fail(nameInput, t('err_name', 'Escribe tu nombre.'), nameInput.closest('.tf-field'));
      }
      if (!validEmail(state.email)) {
        return fail(emailInput, t('err_email', 'Escribe un email válido.'), emailInput.closest('.tf-field'));
      }
      if (!validPhone(state.phone)) {
        return fail(phoneInput, t('err_phone', 'Escribe un teléfono válido.'), phoneInput.closest('.tf-field'));
      }
      return true;
    }

    return true;
  }

  /* ----------------------------------------------------------------------
     10. Cambio de paso

     El paso saliente se anima hacia arriba, se oculta, y solo ENTONCES se
     pinta el entrante. Encadenarlos evita que la página dé un salto cuando
     los dos pasos miden distinto, que es lo que pasaba solapándolos.
  ---------------------------------------------------------------------- */
  var wizard = $('[data-tf-wizard]');
  var progressFill = $('[data-tf-progress-fill]');
  var progressCurrent = $('[data-tf-progress-current]');
  var progressTotal = $('[data-tf-progress-total]');
  var progressLabel = $('[data-tf-progress-label]');
  var backBtn = $('[data-tf-back]');
  var nextBtn = $('[data-tf-next]');
  var submitBtn = $('[data-tf-submit]');
  var busy = false;

  function paintProgress() {
    if (progressFill) progressFill.style.setProperty('--tf-progress', (state.step / TOTAL) * 100 + '%');
    if (progressCurrent) progressCurrent.textContent = pad(state.step);
    if (progressTotal) progressTotal.textContent = pad(TOTAL);

    var stepEl = $('[data-tf-step="' + state.step + '"]');
    if (progressLabel && stepEl) progressLabel.textContent = stepEl.getAttribute('data-tf-label') || '';

    /* «Atrás» se esconde en el paso 1, pero sigue ocupando su hueco: si
       desapareciera, «Siguiente» saltaría de sitio al llegar al paso 2. */
    if (backBtn) backBtn.classList.toggle('is-hidden', state.step === 1);

    /* El paso 7 cambia el botón: ya no hay «Siguiente», hay «Enviar». */
    if (nextBtn) nextBtn.hidden = state.step === TOTAL;
    if (submitBtn) submitBtn.hidden = state.step !== TOTAL;
  }

  function go(n, opts) {
    if (busy) return;
    n = Math.max(1, Math.min(TOTAL, n));
    if (n === state.step && !(opts && opts.force)) return;

    var from = $('[data-tf-step="' + state.step + '"]');
    var to = $('[data-tf-step="' + n + '"]');
    if (!to) return;

    /* Antes de entrar en el 7 se repinta el resumen: es la única pantalla que
       se construye desde `state` en vez de estar escrita en el Liquid. */
    if (n === TOTAL) renderSummary();

    var enter = function () {
      state.step = n;
      to.classList.add('is-active');
      to.classList.remove('is-leaving');
      if (!prefersReduced) {
        to.classList.add('is-entering');
        window.setTimeout(function () {
          to.classList.remove('is-entering');
        }, 420);
      }
      paintProgress();
      busy = false;

      /* El foco va al título del paso (tabindex="-1"): quien navega con
         teclado o lector de pantalla aterriza donde empieza el contenido
         nuevo, no al principio del documento. */
      var head = $('[data-tf-focus]', to);
      if (head && opts && opts.focus !== false) {
        try {
          head.focus({ preventScroll: true });
        } catch (e) {
          head.focus();
        }
      }

      /* Dos capas pegajosas por encima del contenido: la cabecera del sitio y
         la barra de progreso. Se descuentan las dos, o el título del paso
         aterriza justo debajo de ellas y parece cortado. */
      if (wizard) {
        var headerH = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-group-h')
        ) || 0;
        var bar = $('.tf-progress');
        var barH = bar ? bar.getBoundingClientRect().height : 0;
        var y = wizard.getBoundingClientRect().top + window.pageYOffset - headerH - barH - 8;
        window.scrollTo({ top: Math.max(0, y), behavior: prefersReduced ? 'auto' : 'smooth' });
      }
    };

    if (!from || from === to || prefersReduced) {
      if (from && from !== to) from.classList.remove('is-active');
      enter();
      return;
    }

    busy = true;
    from.classList.add('is-leaving');
    window.setTimeout(function () {
      from.classList.remove('is-active', 'is-leaving');
      enter();
    }, 180);
  }

  on(nextBtn, 'click', function () {
    if (validate(state.step)) go(state.step + 1);
  });

  on(backBtn, 'click', function () {
    hideNavNote();
    go(state.step - 1);
  });

  /* Enlaces «Editar» del resumen. */
  $$('[data-tf-edit]').forEach(function (btn) {
    on(btn, 'click', function () {
      go(parseInt(btn.getAttribute('data-tf-edit'), 10));
    });
  });

  /* Enter dentro de un campo avanza de paso en vez de enviar el formulario a
     medias (el <form> envuelve los siete pasos, así que sin esto el Intro del
     paso 1 dispararía el envío). En el textarea de observaciones no: ahí Enter
     es un salto de línea. */
  on(root, 'keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var el = ev.target;
    if (!el || el.tagName === 'TEXTAREA' || el.tagName === 'BUTTON') return;
    if (el.tagName === 'INPUT' && el.type !== 'file') {
      ev.preventDefault();
      if (state.step === TOTAL) return;
      if (validate(state.step)) go(state.step + 1);
    }
  });

  /* ----------------------------------------------------------------------
     11. Resumen (paso 7)

     Se construye desde `state`, nunca leyendo el DOM de los pasos anteriores:
     así el resumen no puede quedar desincronizado con lo elegido.

     Las etiquetas traducibles de las opciones (tipo de prenda, ubicación del
     logo) se leen del rótulo de la propia tarjeta elegida en vez de repetirlas
     en el JSON de textos: hay una sola fuente por idioma y no puede haber dos
     redacciones del mismo concepto.
  ---------------------------------------------------------------------- */
  function labelOf(group, value) {
    var btn = $('[data-tf-group="' + group + '"][data-tf-value="' + value + '"]');
    if (!btn) return value || '';
    var title = $('.tf-cell__title', btn);
    return (title ? title.textContent : btn.textContent).trim();
  }

  function sum(key) {
    return $('[data-tf-sum="' + key + '"]');
  }

  function setSum(key, value, mutedIfEmpty) {
    var el = sum(key);
    if (!el) return;
    var empty = !value;
    el.textContent = empty ? mutedIfEmpty || t('sum_empty', '—') : value;
    el.classList.toggle('tf-row__val--muted', empty);
  }

  function renderSummary() {
    setSum('team', state.team);
    setSum(
      'members',
      state.members
        ? state.members + ' ' + (state.members === 1 ? t('member_one', 'integrante') : t('member_other', 'integrantes'))
        : ''
    );
    setSum('garment', state.garment ? labelOf('garment', state.garment) : '');

    /* Productos: miniatura + nombre. */
    var box = sum('products');
    if (box) {
      box.innerHTML = '';
      var list = pickedAll();
      if (!list.length) {
        var none = document.createElement('span');
        none.className = 'tf-row__val tf-row__val--muted';
        none.textContent = t('sum_empty', '—');
        box.appendChild(none);
      } else {
        list.forEach(function (item) {
          var chip = document.createElement('span');
          chip.className = 'tf-picked__item';
          if (item.image) {
            var img = document.createElement('img');
            img.className = 'tf-picked__thumb';
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            chip.appendChild(img);
          }
          var label = document.createElement('span');
          label.textContent = item.title;
          chip.appendChild(label);
          box.appendChild(chip);
        });
      }
    }

    setSum('logo', state.logo ? labelOf('logo', state.logo) : '');

    /* Ubicación y archivo solo tienen sentido si hay logotipo: las filas se
       esconden enteras en vez de quedarse con un guion, que se leería como
       «falta por rellenar». */
    var withLogo = state.logo === 'yes';
    var spotRow = $('[data-tf-row="spot"]');
    var fileRow = $('[data-tf-row="file"]');
    if (spotRow) spotRow.hidden = !withLogo;
    if (fileRow) fileRow.hidden = !withLogo;

    if (withLogo) {
      setSum('spot', state.spot ? labelOf('spot', state.spot) : '');
      setSum('file', state.file ? state.file.name : '', t('sum_no_file', 'Sin archivo adjunto'));
    }

    setSum('notes', state.notes, t('sum_no_notes', 'Sin observaciones'));
    setSum('name', state.name);
    setSum('email', state.email);
    setSum('phone', state.phone);
  }

  /* ----------------------------------------------------------------------
     12. Envío

     Hay DOS caminos, y cuál se usa depende de un solo ajuste del editor:

     · SIN «URL de recepción» — la solicitud viaja por el formulario nativo de
       Shopify ({% form 'contact' %}). Llega siempre y sin depender de nadie,
       pero es texto y nada más: el formulario de contacto de Shopify NO admite
       adjuntos, así que del logotipo solo consta el nombre.

     · CON «URL de recepción» — el navegador arma un PDF con TODA la solicitud
       (datos, fotos de los productos elegidos y el logotipo incrustado) y lo
       manda por POST multipart junto con el logotipo original y todos los
       campos sueltos. Es el camino que hace que el correo llegue con todo
       junto. Si algo falla por el camino se cae al formulario de Shopify, para
       que una solicitud nunca se pierda por un fallo de red.
  ---------------------------------------------------------------------- */
  var form = $('[data-tf-form]');
  var endpoint = (root.getAttribute('data-tf-endpoint') || '').trim();
  /* 'multipart' (servicios de formularios) o 'json' (receptor propio). */
  var endpointFormat = (root.getAttribute('data-tf-endpoint-format') || 'multipart').trim();
  var PDF_LIB = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js';

  function line(label, value) {
    return label + ': ' + value + '\n';
  }

  function buildBody() {
    var out = '';
    var rule = '\n------------------------------\n';

    out += t('body_heading', 'SOLICITUD TEAM FIT') + '\n';

    out += rule + t('sec_team', 'EQUIPO').toUpperCase() + '\n';
    out += line(t('f_team', 'Nombre del equipo'), state.team);
    out += line(t('f_members', 'Integrantes'), state.members);

    out += rule + t('sec_garment', 'PRENDAS').toUpperCase() + '\n';
    out += line(t('f_garment', 'Tipo'), labelOf('garment', state.garment));
    activeCats().forEach(function (cat) {
      var names = state.picked[cat].map(function (p) {
        return p.title;
      });
      out += line(
        cat === 'polo' ? t('cat_polo', 'Polos') : t('cat_jersey', 'Jerseys'),
        names.length ? names.join(', ') : '—'
      );
    });

    out += rule + t('sec_custom', 'PERSONALIZACIÓN').toUpperCase() + '\n';
    out += line(t('f_logo', 'Logotipo'), state.logo ? labelOf('logo', state.logo) : '—');
    if (state.logo === 'yes') {
      out += line(t('f_spot', 'Ubicación'), state.spot ? labelOf('spot', state.spot) : '—');
      if (state.file) {
        var fileNote = state.file.name + ' (' + humanSize(state.file.size) + ')';
        /* Sin URL de recepción el archivo no viaja a ninguna parte: hay que
           decirlo, o el nombre a secas se lee como si fuera un adjunto. */
        if (!endpoint) fileNote += '\n' + t('f_file_pending', 'Pendiente de recibir: pídeselo al cliente por email.');
        out += line(t('f_file', 'Archivo'), fileNote);
      } else {
        out += line(t('f_file', 'Archivo'), t('sum_no_file', 'Sin archivo adjunto'));
      }
    }

    out += rule + t('sec_notes', 'OBSERVACIONES').toUpperCase() + '\n';
    out += (state.notes || t('sum_no_notes', 'Sin observaciones')) + '\n';

    out += rule + t('sec_contact', 'CONTACTO').toUpperCase() + '\n';
    out += line(t('f_name', 'Nombre'), state.name);
    out += line(t('f_email', 'Email'), state.email);
    out += line(t('f_phone', 'Teléfono'), state.phone);

    return out;
  }

  /* ----------------------------------------------------------------------
     12 bis. El PDF

     Se arma en el navegador con jsPDF, que se descarga solo al pulsar
     «Enviar» y solo si hay URL de recepción: quien únicamente mira la página
     no paga esos kilobytes. Si la librería no carga, la solicitud sale igual
     sin PDF — el adjunto es un extra, no un requisito.
  ---------------------------------------------------------------------- */
  var FONT_URL = (root.getAttribute('data-tf-fonts') || '').trim();

  /* Descarga un <script> y avisa; nunca rechaza, porque ninguna de las dos
     piezas es imprescindible: sin jsPDF no hay PDF pero la solicitud sale
     igual, y sin la tipografía el PDF sale en Helvetica. */
  function loadScript(url, done) {
    return new Promise(function (resolve) {
      if (!url || done()) return resolve(done());
      var tag = document.createElement('script');
      tag.src = url;
      tag.async = true;
      tag.onload = function () { resolve(done()); };
      tag.onerror = function () { resolve(false); };
      document.head.appendChild(tag);
      /* Tope propio: si el servidor se queda colgado no se espera para siempre. */
      window.setTimeout(function () { resolve(done()); }, 8000);
    });
  }

  function loadPdfLib() {
    return Promise.all([
      loadScript(PDF_LIB, function () { return !!(window.jspdf && window.jspdf.jsPDF); }),
      loadScript(FONT_URL, function () { return !!window.TeamFitFonts; })
    ]).then(function (res) {
      /* Solo jsPDF decide si hay PDF; la tipografía es un lujo opcional. */
      return res[0];
    });
  }

  /* Normaliza CUALQUIER imagen a un JPEG, opcionalmente recortada a una
     proporción.

     Por qué pasa por un <canvas> en vez de mandar el archivo tal cual: los
     motores de PDF solo digieren JPEG y PNG bien formados, y aquí puede llegar
     de todo —PNG entrelazados o con paleta, WebP (que es lo que sirve la CDN
     de Shopify muchas veces), SVG—. El navegador sabe pintar todo eso; una vez
     en el lienzo, lo que sale es un JPEG normal y corriente.

     El recorte se hace AQUÍ y no en el PDF: recortar dentro del documento
     obliga a manejar estados gráficos y máscaras, y se rompe con facilidad.
     Recortando antes, la imagen ya llega con la forma exacta de su hueco.

     Devuelve null si algo falla —lienzo contaminado por CORS, formato
     ilegible, red— y entonces el documento sale sin esa imagen. Un adjunto es
     un extra: nunca puede tumbar el envío. */
  function toPdfImage(source, maxSide, aspect) {
    return new Promise(function (resolve) {
      var isBlob = source instanceof Blob;
      var url = isBlob ? window.URL.createObjectURL(source) : source;
      var img = new Image();
      var done = false;

      function finish(value) {
        if (done) return;
        done = true;
        if (isBlob) window.URL.revokeObjectURL(url);
        resolve(value);
      }

      img.onload = function () {
        try {
          var iw = img.naturalWidth || img.width;
          var ih = img.naturalHeight || img.height;
          if (!iw || !ih) return finish(null);

          /* Zona del original que se conserva. Sin `aspect` se conserva entera. */
          var sx = 0;
          var sy = 0;
          var sw = iw;
          var sh = ih;
          if (aspect) {
            if (iw / ih > aspect) {
              sw = ih * aspect;
              sx = (iw - sw) / 2;
            } else {
              sh = iw / aspect;
              sy = (ih - sh) / 2;
            }
          }

          var scale = Math.min(1, maxSide / Math.max(sw, sh));
          var cw = Math.max(1, Math.round(sw * scale));
          var ch = Math.max(1, Math.round(sh * scale));

          var canvas = document.createElement('canvas');
          canvas.width = cw;
          canvas.height = ch;
          var ctx = canvas.getContext('2d');

          /* El fondo del tema debajo: JPEG no guarda transparencia y sin esto
             un logotipo con fondo transparente saldría sobre negro. */
          ctx.fillStyle = '#F6F6F6';
          ctx.fillRect(0, 0, cw, ch);
          ctx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);

          finish({ data: canvas.toDataURL('image/jpeg', 0.85), width: cw, height: ch });
        } catch (e) {
          finish(null);
        }
      };
      img.onerror = function () {
        finish(null);
      };

      /* Las fotos vienen de la CDN de Shopify, que responde con CORS abierto;
         sin este atributo el lienzo queda contaminado y toDataURL lanza. */
      if (!isBlob) img.crossOrigin = 'anonymous';
      img.src = url;

      window.setTimeout(function () {
        finish(null);
      }, 8000);
    });
  }

  /* ----------------------------------------------------------------------
     12 bis. El documento

     A4 vertical con el mismo lenguaje que la web: banda de marca arriba con el
     nombre del equipo en display, secciones separadas por filetes, rótulos
     diminutos en versalitas y Switzer de principio a fin.

     ---------------------------------------------------------------------
     Por qué pdf-lib y no jsPDF

     Switzer es una fuente CFF (contornos PostScript). El subconjuntador de
     jsPDF solo escribe TrueType válido: con una CFF genera un SFNT que los
     visores rechazan («SFNT font table missing») y el PDF sale con una fuente
     sustituta o con los glifos corridos. Se probó convirtiendo CFF a TrueType
     con cu2qu y aun así jsPDF escribía un SFNT roto.

     pdf-lib + fontkit incrusta CFF tal cual, y el texto sigue siendo
     seleccionable y copiable — que en un presupuesto importa: el comercial
     tiene que poder copiar el email y el teléfono.

     Las tres piezas (pdf-lib, fontkit y la tipografía) se descargan SOLO al
     pulsar «Enviar» y solo si hay URL de recepción. Quien se limita a mirar la
     página no paga esos kilobytes.
  ---------------------------------------------------------------------- */
  var PDF_LIB = 'https://cdn.jsdelivr.net/npm/pdf-lib@1.17.1/dist/pdf-lib.min.js';
  var FONTKIT_LIB = 'https://cdn.jsdelivr.net/npm/@pdf-lib/fontkit@1.1.1/dist/fontkit.umd.min.js';
  var FONT_URL = (root.getAttribute('data-tf-fonts') || '').trim();

  /* Descarga un <script> y avisa de si la pieza quedó disponible; nunca
     rechaza, porque ninguna es imprescindible: sin pdf-lib no hay PDF pero la
     solicitud sale igual, y sin la tipografía sale con la de serie. */
  function loadScript(url, ready) {
    return new Promise(function (resolve) {
      if (!url || ready()) return resolve(ready());
      var tag = document.createElement('script');
      tag.src = url;
      tag.async = true;
      tag.onload = function () { resolve(ready()); };
      tag.onerror = function () { resolve(false); };
      document.head.appendChild(tag);
      /* Tope propio: si el CDN se queda colgado no se espera para siempre. */
      window.setTimeout(function () { resolve(ready()); }, 10000);
    });
  }

  function loadPdfLib() {
    return Promise.all([
      loadScript(PDF_LIB, function () { return !!window.PDFLib; }),
      loadScript(FONTKIT_LIB, function () { return !!window.fontkit; }),
      loadScript(FONT_URL, function () { return !!window.TeamFitFonts; })
    ]).then(function (res) {
      return res[0];
    });
  }

  function b64ToBytes(b64) {
    var bin = window.atob(b64);
    var out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function buildPdf() {
    return loadPdfLib().then(function (ready) {
      if (!ready) return null;

      var shots = pickedAll();
      /* Las fotos se recortan a 4/5, la proporción de las tarjetas de la web,
         y se piden todas a la vez. */
      var jobs = shots.map(function (item) {
        return item.image ? toPdfImage(item.image, 520, 0.8) : Promise.resolve(null);
      });
      /* El logotipo NO se recorta: se enseña entero, como lo mandó el cliente.
         El SVG también entra, porque el navegador sabe pintarlo en el lienzo. */
      var logoJob = state.file && /^image\//.test(state.file.type)
        ? toPdfImage(state.file, 700)
        : Promise.resolve(null);

      return Promise.all([Promise.all(jobs), logoJob]).then(function (res) {
        return draw(res[0], res[1], shots);
      });
    });
  }

  function draw(images, logo, shots) {
    var L = window.PDFLib;
    var rgb = L.rgb;

    /* Paleta del tema, en la escala 0-1 que usa pdf-lib. */
    var BRAND = rgb(62 / 255, 78 / 255, 70 / 255);
    var SURFACE = rgb(246 / 255, 246 / 255, 246 / 255);
    var MUTED = rgb(104 / 255, 117 / 255, 110 / 255);
    var LINE = rgb(224 / 255, 226 / 255, 225 / 255);
    var MEDIA = rgb(228 / 255, 229 / 255, 228 / 255);

    return L.PDFDocument.create().then(function (doc) {
      if (window.fontkit) doc.registerFontkit(window.fontkit);

      var fonts = window.TeamFitFonts;
      var embed = function (which, fallback) {
        if (fonts && fonts[which] && window.fontkit) {
          /* subset: false a propósito. El archivo que llega YA viene
             subconjuntado desde el build (solo latino occidental), así que
             volver a subconjuntarlo no ahorra nada — y el subconjuntador de
             fontkit escribe un CFF que algunos visores no reconocen
             («unknown file format»). Incrustada tal cual, la lee todo el
             mundo. */
          return doc.embedFont(b64ToBytes(fonts[which]), { subset: false });
        }
        return doc.embedFont(fallback);
      };

      return Promise.all([
        embed('regular', L.StandardFonts.Helvetica),
        embed('bold', L.StandardFonts.HelveticaBold),
        embed('extrabold', L.StandardFonts.HelveticaBold)
      ]).then(function (f) {
        var REG = f[0];
        var BOLD = f[1];
        var DISPLAY = f[2];

        var W = 595.28;
        var H = 841.89;
        var M = 46;
        var COL = W - M * 2;
        var BAND = 150;
        var KEY_W = 150;

        var pages = [];
        var page = null;
        var y = 0; // medida DESDE ARRIBA; se convierte al dibujar

        function addPage() {
          page = doc.addPage([W, H]);
          pages.push(page);
          page.drawRectangle({ x: 0, y: 0, width: W, height: H, color: SURFACE });
          y = M + 20;
          return page;
        }

        /* pdf-lib mide desde abajo; todo el maquetado de aquí piensa desde
           arriba, que es como se lee. Esta es la única conversión. */
        function T(top) {
          return H - top;
        }

        function width(str, font, size, spacing) {
          var w = font.widthOfTextAtSize(String(str), size);
          return spacing ? w + spacing * (String(str).length - 1) : w;
        }

        /* pdf-lib no sabe de tracking, y el rótulo diminuto en versalitas con
           la letra abierta es media identidad de esta web. Se dibuja carácter
           a carácter cuando hace falta; son rótulos de tres palabras. */
        function text(str, x, top, opt) {
          var s = String(str == null ? '' : str);
          var o = opt || {};
          var font = o.font || REG;
          var size = o.size || 10;
          var color = o.color || BRAND;
          var x0 = x;
          if (o.align === 'right') x0 = x - width(s, font, size, o.spacing);

          if (!o.spacing) {
            page.drawText(s, { x: x0, y: T(top), size: size, font: font, color: color });
            return;
          }
          var cx = x0;
          for (var i = 0; i < s.length; i++) {
            var ch = s.charAt(i);
            page.drawText(ch, { x: cx, y: T(top), size: size, font: font, color: color });
            cx += font.widthOfTextAtSize(ch, size) + o.spacing;
          }
        }

        function wrap(str, font, size, maxW) {
          var words = String(str == null ? '' : str).split(/\s+/);
          var lines = [];
          var line = '';
          for (var i = 0; i < words.length; i++) {
            var next = line ? line + ' ' + words[i] : words[i];
            if (font.widthOfTextAtSize(next, size) > maxW && line) {
              lines.push(line);
              line = words[i];
            } else {
              line = next;
            }
          }
          if (line) lines.push(line);
          return lines.length ? lines : [''];
        }

        function rule(top) {
          page.drawLine({
            start: { x: M, y: T(top) },
            end: { x: W - M, y: T(top) },
            thickness: 0.75,
            color: LINE
          });
        }

        /* Salta de página si lo que viene no cabe entero. */
        function room(need) {
          if (y + need > H - M - 30) addPage();
        }

        /* ---------- Cabecera ----------
           El equivalente del hero de la web: banda oscura, rótulo diminuto en
           versalitas y el nombre del equipo grande encima. */
        addPage();
        y = 0;
        page.drawRectangle({ x: 0, y: T(BAND), width: W, height: BAND, color: BRAND });

        text(t('body_heading', 'SOLICITUD TEAM FIT').toUpperCase(), M, 44, {
          font: BOLD, size: 8, color: SURFACE, spacing: 1.1
        });

        var teamLines = wrap((state.team || '—').toUpperCase(), DISPLAY, 25, COL - 140).slice(0, 2);
        for (var i = 0; i < teamLines.length; i++) {
          text(teamLines[i], M, 84 + i * 27, { font: DISPLAY, size: 25, color: SURFACE });
        }

        var stamp = new Date().toLocaleDateString(undefined, {
          year: 'numeric', month: 'long', day: 'numeric'
        });
        text(stamp, W - M, 44, { font: REG, size: 9, color: SURFACE, align: 'right' });
        text(
          state.members + ' ' + (state.members === 1 ? t('member_one', 'integrante') : t('member_other', 'integrantes')),
          W - M, BAND - 26, { font: REG, size: 9, color: SURFACE, align: 'right' }
        );

        y = BAND + 46;

        /* ---------- Piezas ---------- */
        function section(title) {
          /* Reserva para el rótulo, el filete y dos filas: lo justo para que un
             bloque no empiece al final de una página dejando el titular solo. */
          room(96);
          text(String(title).toUpperCase(), M, y, { font: BOLD, size: 8, color: MUTED, spacing: 1.1 });
          y += 11;
          rule(y);
          y += 23;
        }

        function row(key, value) {
          var lines = wrap(value == null || value === '' ? '—' : value, REG, 10.5, COL - KEY_W);
          room(lines.length * 15 + 8);
          text(key, M, y, { font: REG, size: 9, color: MUTED });
          for (var i = 0; i < lines.length; i++) {
            text(lines[i], M + KEY_W, y + i * 15, { font: REG, size: 10.5, color: BRAND });
          }
          y += lines.length * 15 + 9;
        }

        /* ---------- Equipo ---------- */
        section(t('sec_team', 'Equipo'));
        row(t('f_team', 'Nombre del equipo'), state.team);
        row(
          t('f_members', 'Integrantes'),
          state.members + ' ' + (state.members === 1 ? t('member_one', 'integrante') : t('member_other', 'integrantes'))
        );
        y += 14;

        /* ---------- Prendas ---------- */
        section(t('sec_garment', 'Prendas'));
        row(t('f_garment', 'Tipo'), labelOf('garment', state.garment));
        activeCats().forEach(function (cat) {
          var names = state.picked[cat].map(function (p) { return p.title; });
          row(cat === 'polo' ? t('cat_polo', 'Polos') : t('cat_jersey', 'Jerseys'), names.join(', '));
        });

        /* Tira de fotos: el comercial ve de un vistazo qué le han pedido sin
           tener que buscar los productos en el catálogo. */
        /* Cuatro por fila y no tres: con tres, una solicitud corriente se
           partía en dos páginas por diez puntos. Un presupuesto de una sola
           página se lee mejor. */
        var PER = 4;
        var GAP = 18;
        var TW = (COL - GAP * (PER - 1)) / PER;
        var TH = TW * 1.25;
        var drawn = 0;
        var pending = [];

        shots.forEach(function (item, i) {
          if (images[i]) pending.push({ img: images[i], title: item.title });
        });

        return pending
          .reduce(function (chain, it) {
            return chain.then(function () {
              return doc.embedJpg(it.img.data).then(function (embedded) {
                var col = drawn % PER;
                if (col === 0) {
                  room(TH + 36);
                  y += 10;
                }
                var x = M + col * (TW + GAP);
                page.drawRectangle({ x: x, y: T(y + TH), width: TW, height: TH, color: MEDIA });
                /* Ya viene recortada a 4/5 desde el lienzo, así que llena el
                   hueco exacto sin deformarse ni necesitar máscara. */
                page.drawImage(embedded, { x: x, y: T(y + TH), width: TW, height: TH });
                var nameLines = wrap(it.title, REG, 8.5, TW).slice(0, 2);
                for (var k = 0; k < nameLines.length; k++) {
                  text(nameLines[k], x, y + TH + 14 + k * 11, { font: REG, size: 8.5, color: MUTED });
                }
                drawn += 1;
                if (drawn % PER === 0) y += TH + 34;
              });
            });
          }, Promise.resolve())
          .then(function () {
            if (drawn && drawn % PER !== 0) y += TH + 34;
            y += 14;

            /* ---------- Personalización ---------- */
            section(t('sec_custom', 'Personalización'));
            row(t('f_logo', 'Logotipo'), state.logo ? labelOf('logo', state.logo) : '—');
            if (state.logo !== 'yes') return null;

            row(t('f_spot', 'Ubicación'), state.spot ? labelOf('spot', state.spot) : '—');
            row(
              t('f_file', 'Archivo'),
              state.file ? state.file.name + '  ·  ' + humanSize(state.file.size) : t('sum_no_file', 'Sin archivo adjunto')
            );
            if (!logo) return null;

            return doc.embedJpg(logo.data).then(function (embedded) {
              /* Nunca se amplía por encima de su resolución: un logotipo de
                 16 px estirado se ve como una cuadrícula de píxeles. */
              var ls = Math.min(150 / logo.width, 130 / logo.height, 1);
              var lw = logo.width * ls;
              var lh = logo.height * ls;
              room(lh + 26);
              y += 8;
              page.drawImage(embedded, { x: M + KEY_W, y: T(y + lh), width: lw, height: lh });
              y += lh + 18;
            });
          })
          .then(function () {
            y += 16;

            /* ---------- Observaciones ---------- */
            section(t('sec_notes', 'Observaciones'));
            var notes = wrap(state.notes || t('sum_no_notes', 'Sin observaciones'), REG, 10.5, COL);
            room(notes.length * 15);
            for (var i = 0; i < notes.length; i++) {
              text(notes[i], M, y + i * 15, { font: REG, size: 10.5, color: BRAND });
            }
            y += notes.length * 15 + 22;

            /* ---------- Contacto ---------- */
            section(t('sec_contact', 'Contacto'));
            row(t('f_name', 'Nombre'), state.name);
            row(t('f_email', 'Email'), state.email);
            row(t('f_phone', 'Teléfono'), state.phone);

            /* ---------- Pie, en todas las páginas ----------
               Al final porque hasta aquí no se sabe cuántas hay. */
            for (var pg = 0; pg < pages.length; pg++) {
              page = pages[pg];
              rule(H - M - 18);
              text('OSTRICH GOLF · TEAM FIT', M, H - M, {
                font: BOLD, size: 7.5, color: MUTED, spacing: 1
              });
              text(pg + 1 + ' / ' + pages.length, W - M, H - M, {
                font: BOLD, size: 7.5, color: MUTED, align: 'right'
              });
            }

            return doc.save().then(function (bytes) {
              return new Blob([bytes], { type: 'application/pdf' });
            });
          });
      });
    });
  }

  /* ----------------------------------------------------------------------
     12 ter. Los dos caminos de envío
  ---------------------------------------------------------------------- */
  function setBusy(is) {
    if (!submitBtn) return;
    submitBtn.classList.toggle('is-busy', is);
    submitBtn.disabled = is;
    var spin = $('[data-tf-spin]', submitBtn);
    var arrow = $('[data-tf-arrow]', submitBtn);
    if (spin) spin.hidden = !is;
    if (arrow) arrow.hidden = is;
  }

  function fillAndSubmit() {
    var map = { name: state.name, email: state.email, phone: state.phone, body: buildBody() };
    Object.keys(map).forEach(function (key) {
      var input = $('[data-tf-hidden="' + key + '"]');
      if (input) input.value = map[key];
    });
    /* `submit()` y no `requestSubmit()`: el botón es type="button" y aquí ya
       se ha validado a mano, así que no hay que volver a pasar por la
       validación nativa del navegador sobre campos que están ocultos. */
    form.submit();
  }

  /* Confirmación sin recargar: es la que se usa cuando la solicitud ha ido por
     la URL de recepción. Con el formulario de Shopify no hace falta, porque la
     tienda recarga la página y el Liquid ya pinta este mismo panel. */
  var donePanel = $('[data-tf-done]');

  function showDone() {
    if (intro) intro.hidden = true;
    if (wizard) wizard.hidden = true;
    if (donePanel) donePanel.hidden = false;
    root.setAttribute('data-tf-view', 'done');
    window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
  }

  /* Un Blob a base64 (sin la cabecera «data:...;base64,»). */
  function blobToBase64(blob) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function () {
        var out = String(reader.result || '');
        var comma = out.indexOf(',');
        resolve(comma > -1 ? out.slice(comma + 1) : '');
      };
      reader.onerror = function () { resolve(''); };
      reader.readAsDataURL(blob);
    });
  }

  /* Los campos de la solicitud, con nombres legibles: así el correo del
     servicio de recepción se lee como una ficha y no como un volcado. */
  function requestFields() {
    var out = [];
    out.push([t('f_name', 'Nombre'), state.name]);
    out.push([t('f_email', 'Email'), state.email]);
    out.push([t('f_phone', 'Teléfono'), state.phone]);
    out.push([t('f_team', 'Equipo'), state.team]);
    out.push([t('f_members', 'Integrantes'), String(state.members)]);
    out.push([t('f_garment', 'Prendas'), labelOf('garment', state.garment)]);
    activeCats().forEach(function (cat) {
      out.push([
        cat === 'polo' ? t('cat_polo', 'Polos') : t('cat_jersey', 'Jerseys'),
        state.picked[cat].map(function (p) { return p.title; }).join(', ')
      ]);
    });
    out.push([t('f_logo', 'Logotipo'), state.logo ? labelOf('logo', state.logo) : '—']);
    if (state.logo === 'yes') {
      out.push([t('f_spot', 'Ubicación'), state.spot ? labelOf('spot', state.spot) : '—']);
    }
    out.push([t('sec_notes', 'Observaciones'), state.notes || t('sum_no_notes', 'Sin observaciones')]);
    return out;
  }

  function pdfName() {
    var raw = String(state.team || 'team-fit');
    /* Se descomponen los acentos y se retiran las marcas, para que «Empordà»
       quede en «emporda» y no en «empord». El nombre del archivo se queda en
       ASCII porque no todos los clientes de correo tratan bien un adjunto con
       caracteres altos. */
    if (raw.normalize) raw = raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    var safe = raw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return 'solicitud-' + (safe || 'team-fit') + '.pdf';
  }

  /* ---------- Envío en JSON ----------
     Es el formato para un receptor propio (un Apps Script de Google es la
     receta que documentamos): Apps Script NO sabe parsear multipart, pero lee
     el cuerpo crudo sin problema, así que los adjuntos viajan en base64.

     Content-Type text/plain a propósito: es uno de los tipos que el navegador
     considera «simples», así que no dispara una petición OPTIONS previa — y
     Apps Script no sabe responder a un preflight. */
  function sendAsJson(pdf, mode) {
    var files = [];
    var jobs = [];

    if (pdf) {
      jobs.push(blobToBase64(pdf).then(function (b64) {
        if (b64) files.push({ name: pdfName(), type: 'application/pdf', base64: b64 });
      }));
    }
    if (state.file) {
      jobs.push(blobToBase64(state.file).then(function (b64) {
        if (b64) files.push({ name: state.file.name, type: state.file.type || 'application/octet-stream', base64: b64 });
      }));
    }

    return Promise.all(jobs).then(function () {
      var fields = {};
      requestFields().forEach(function (pair) { fields[pair[0]] = pair[1]; });
      var body = JSON.stringify({
        subject: t('body_heading', 'SOLICITUD TEAM FIT') + ' — ' + state.team,
        replyTo: state.email,
        /* Sueltos y con nombre fijo: los de `fields` van traducidos y cambian
           con el idioma, así que el receptor no puede buscarlos por su
           rótulo. */
        team: state.team,
        members: state.members,
        fields: fields,
        summary: buildBody(),
        files: files
      });
      var opts = { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain;charset=utf-8' } };
      if (mode) opts.mode = mode;
      return fetch(endpoint, opts);
    });
  }

  /* ---------- Envío multipart ----------
     El formato que esperan los servicios de formularios al uso (Formspree,
     Basin, un webhook de Zapier o Make). */
  function sendAsMultipart(pdf, mode) {
    var payload = new FormData();

    payload.append('_subject', t('body_heading', 'SOLICITUD TEAM FIT') + ' — ' + state.team);
    payload.append('email', state.email);
    requestFields().forEach(function (pair) {
      payload.append(pair[0], pair[1]);
    });
    /* Y el texto completo, por si al otro lado hay un webhook pelado que no
       sabe qué hacer con los campos sueltos. */
    payload.append('resumen', buildBody());

    /* El logotipo original, tal cual lo subió el cliente: es el archivo que
       hace falta para producción, no la copia incrustada en el PDF. */
    if (state.file) payload.append('logotipo', state.file, state.file.name);
    if (pdf) payload.append('solicitud', pdf, pdfName());

    var opts = { method: 'POST', body: payload, headers: { Accept: 'application/json' } };
    if (mode) opts.mode = mode;
    return fetch(endpoint, opts);
  }

  function sendToEndpoint() {
    var send = endpointFormat === 'json' ? sendAsJson : sendAsMultipart;
    return buildPdf()
      .catch(function () {
        return null;
      })
      .then(function (pdf) {
        return send(pdf)
          .then(function (res) {
            if (!res || !res.ok) throw new Error('http');
            return true;
          })
          .catch(function (err) {
            /* Un error HTTP es un NO de verdad: el servicio ha contestado y ha
               dicho que no. Se propaga para caer al formulario de Shopify. */
            if (err && err.message === 'http') throw err;

            /* Un fallo de red, en cambio, casi siempre es CORS: el navegador
               ha ENVIADO la petición pero no deja leer la respuesta. Es lo que
               pasa con un Apps Script de Google, que es la receta gratuita que
               documentamos. Se reintenta a ciegas (`no-cors`): no se puede
               comprobar el resultado, pero el correo sale. Sin esto la
               solicitud llegaría por partida doble —una con adjuntos y otra
               por Shopify— en cada envío. */
            return send(pdf, 'no-cors').then(function () {
              return true;
            });
          });
      });
  }

  on(submitBtn, 'click', function () {
    if (busy || submitBtn.disabled) return;
    /* Última red: se revalidan los pasos con campos obligatorios por si se ha
       llegado al 7 y luego se ha vaciado algo desde un «Editar». */
    var required = [1, 2, 3, 4, 6];
    for (var i = 0; i < required.length; i++) {
      if (!validate(required[i])) {
        go(required[i], { force: true });
        return;
      }
    }

    setBusy(true);

    if (!endpoint || !window.fetch || !window.FormData) {
      fillAndSubmit();
      return;
    }

    /* Tope de 45 s: armar el PDF con fotos y subirlo lleva más que un POST
       pelado, pero si el servicio no contesta se cae al formulario de Shopify
       en vez de dejar al cliente mirando una ruedecilla. */
    var settled = false;
    var timer = window.setTimeout(function () {
      if (settled) return;
      settled = true;
      fillAndSubmit();
    }, 45000);

    sendToEndpoint()
      .then(function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        setBusy(false);
        showDone();
      })
      .catch(function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        /* El envío enriquecido ha fallado: se manda por Shopify para que la
           solicitud llegue igual, aunque sea sin adjuntos. */
        fillAndSubmit();
      });
  });

  /* ----------------------------------------------------------------------
     13. Landing → wizard

     La landing y el wizard viven en la misma página: el paso de una a otro es
     un fundido, no una recarga, así que arrancar cuesta cero.

     `pushState` para que la flecha «atrás» del navegador devuelva a la
     landing en vez de sacar al usuario del sitio con todo lo escrito dentro.
  ---------------------------------------------------------------------- */
  var intro = $('[data-tf-intro]');
  var startBtns = $$('[data-tf-start]');

  function showWizard(push) {
    if (!wizard) return;
    if (intro) intro.hidden = true;
    wizard.hidden = false;
    root.setAttribute('data-tf-view', 'wizard');
    go(state.step, { force: true });
    if (push && window.history && window.history.pushState) {
      window.history.pushState({ teamFit: 'wizard' }, '', '#team-fit');
    }
  }

  function showIntro() {
    if (!intro) return;
    wizard.hidden = true;
    intro.hidden = false;
    root.setAttribute('data-tf-view', 'intro');
    window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
  }

  startBtns.forEach(function (btn) {
    on(btn, 'click', function (ev) {
      ev.preventDefault();
      showWizard(true);
    });
  });

  on(window, 'popstate', function (ev) {
    var wantsWizard = ev.state && ev.state.teamFit === 'wizard';
    if (wantsWizard) showWizard(false);
    else showIntro();
  });

  /* Entrar directamente con #team-fit (un enlace compartido, o recargar ya
     dentro) salta la landing. */
  if (window.location.hash === '#team-fit' && wizard) showWizard(false);

  /* --- Entrada escalonada de la landing ---
     `is-ready` dispara las transiciones de .tf-rise. Se pone en el siguiente
     fotograma para que el navegador registre el estado inicial; sin esa espera
     la transición no llega a existir y las piezas aparecen de golpe. */
  if (intro) {
    var reveal = function () {
      intro.classList.add('is-ready');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal();
              io.disconnect();
            }
          });
        },
        { threshold: 0.05 }
      );
      io.observe(intro);
    } else {
      reveal();
    }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(reveal);
    });
  }

  /* ----------------------------------------------------------------------
     14. Arranque
  ---------------------------------------------------------------------- */
  toggleLogoBlock(false);
  paintCats();
  paintProgress();
  if (teamInput && teamInput.value) state.team = teamInput.value.trim();
})();
